import { gql } from '@apollo/client';

export const QUERY = gql`
  query TransactionReport($organizationId: Int!, $startDate: String!, $endDate: String!, $recordCount: Int, $dateColumn: String!) {
    transactionFinancialReport(
      input: { startDate: $startDate, endDate: $endDate, recordCount: $recordCount, dateColumn: $dateColumn }
      organizationId: $organizationId
    ) {
      transactionId
      transactionDate
      gross
      net
      fee
      grossAmount
      netAmount
      depositId
      payoutId
      merchantAccountDisplayName
      depositDate
      status
      bankLast4
      paymentLast4
      paymentType
      paymentDescription
      transactionType
      orderId
      orderNumber
      orderType
      userId
      userEmail
      userName
      referenceObjectType
      sourceItems {
        type
        sourceName
        seasonId
        programSeason
        participantFirstName
        participantLastName
        teamId
        teamName
        divisionId
        divisionName
        linkInfo {
          rootDivisionId
          batchInvoiceId
          invoiceId
          registrationFormId
          registrationId
          organizationId
        }
      }
    }
  }
`;

